@if (pmtMeth && !loading) {
<div tabindex="-1" class="m-5" #editCreditCardModal>
  <!-- HEADER BANNER -->
  <div class="row">
    <div class="col-12">
      <div class="page-header-button">
        <h1 [translate]="'payment_EditYourPaymentMethod'"></h1>
        <button type="button" class="close-modal" [ngClass]="language"
                (click)="closeEditCreditCard();"
                trackLink = "{{disableClickTracking ?? 'Close'}}"
                trackType = "{{disableClickTracking ? '':'o'}}"
                [prop15]="('payment_ExpirationDate'| translate)+' month'"
                [prop10]="trackingString('dropdown',['Close'])"
                [evar33]="trackingString('dropdown',['Close'])"
                [attr.aria-label]="'aoda_close_form_label' | translate">
          <span [attr.aria-hidden]="true" class="icon-ui-closedot"></span>
        </button>
      </div>
    </div>
  </div>
  <!-- LOAD ERROR -->
   @if (loadError) {
    <div class="row">
      <ox-alert class="col-12" [type]="'error'">
        <!-- TODO: get message from copy API -->
        <div [translate]="'settings.ice_retrieveError'"></div>
      </ox-alert>
    </div>
   }  

  @if (!loadError && !loading) {
    <form [formGroup]="updatePmthForm">
    <!-- ALERT ERRORS -->
  
    @if (errorSaving) {
      <div class="row">
        <ox-alert class="col-12" [type]="'error'">
          <!-- TODO: get message from copy API -->
          <div [translate]="'settings.ice_retrieveError'"></div>
        </ox-alert>
      </div>
    }

    <!-- Shows CC type icon and info -->
    <svg class="icon-pay-visa mb-1">
      <use id="svg-payment-type" alt="Payment Method Icon"
      [attr.href]="getPaymentMethodImage(pmtMeth)"></use>
    </svg>
    <div class="mb-2">
      <span [ngClass]="{'error-red-text': displayErrorRedText(pmtMeth)}">
        <!-- TODO: get text from copy API -->
        @if (pmtMeth.creditCard?.expiryStatus === 'EXPIRED') {
          Expired
        }
        
        @else if (getIsPaymentMethodExpiring(pmtMeth)) {
          Expires
        }
         on: {{pmtMeth.creditCard?.expirationMonth}}/{{pmtMeth.creditCard?.expirationYear}} 
      </span>
    </div>
    <!-- form fields -->
    @if (pmtMeth.creditCard) {
      <div class="form-group">
      <!-- Name on card -->
      <div class="row">
        <div class="col-12 col-md-8 col-sm-8 margin-bottom-medium">
          <ox-text-input
            [id]="'account_holder_name'"
            [label]="'payment_NameOnCreditCard'"
            [formGroupInput]="updatePmthForm"
            formControlNameInput="accountHolderName"
            [placeHolderText]="pmtMeth.creditCard.displayName"
            inputName="Test Name"
            classes="form-control"
            (input)="isFormChanged($event)"
            trackLink = "{{disableClickTracking ?? ('payment_NameOnCreditCard'| translate)}}"
            trackType = "{{disableClickTracking ? '':'o'}}"
            [prop15]="('payment_NameOnCreditCard'| translate)+' month'"
            [prop10]="trackingString('input',[('payment_NameOnCreditCard' | translate)])"
            [evar33]="trackingString('input',[('payment_NameOnCreditCard'| translate)])"
            
            ></ox-text-input>
        </div>
      </div>
      <!-- Expiry date -->
      <div class="row">
        <div class="col-12 col-md-8 col-sm-8 margin-bottom-medium">
          <label class="margin-bottom-small">
            <span [translate]="'checkout_edit_payment_expirationDate'" ></span>
          </label>
          <div class="row">
            <div class="col-12 col-sm-6 margin-bottom-small">
              <select class="form-control-custom oc-select-container"
              id="editCreditCardDrawer_expirationMonth"
              name="expirationMonth" 
              formControlName="expirationMonth"
              trackLink = "{{disableClickTracking ?? ('checkout_edit_payment_expirationDate'| translate)+' month'}}"
              trackType = "{{disableClickTracking ? '':'o'}}"
              [prop15]="('checkout_edit_payment_expirationDate'| translate)+' month'"
              [prop10]="trackingString('dropdown',[('checkout_edit_payment_expirationDate' | translate)+' month'])"
              [evar33]="trackingString('dropdown',[('checkout_edit_payment_expirationDate'| translate)+' month'])"
              (change)="isFormChanged($event)">
                @for (month of months; track month) {
                  <option [ngValue]="month.value">{{ month.name }}</option>
                }                  
              </select>
            </div>
            <div class="col-12 col-sm-6 margin-bottom-none">
              <select class="form-control-custom oc-select-container"
              id="expiration_year"
              name="expirationYear"
              trackLink = "{{disableClickTracking ?? ('checkout_edit_payment_expirationDate'| translate)+' year'}}"
              trackType = "{{disableClickTracking ? '':'o'}}"
              [prop15]="('checkout_edit_payment_expirationDate'| translate)+' year'"
              [prop10]="trackingString('dropdown',[('checkout_edit_payment_expirationDate' | translate)+' year'])"
              [evar33]="trackingString('dropdown',[('checkout_edit_payment_expirationDate'| translate)+' year'])"
              formControlName="expirationYear"
              (change)="isFormChanged($event)">
                @for (year of years; track year) {
                  <option [ngValue]="year">{{ year }}</option>
                }           
              </select>
            </div>
          </div>
          @if (expDate) {              
            <div class="error-red-text gb-body4 ml-3 mt-1">
              <div class="medium-icon">
                <span [attr.aria-hidden]="true" class="icon-ui-caution"></span>
                <span class="icon-svg-text ml-1" [translate]="'expires_before_current_date_error'"></span>
              </div>
            </div>
          }
        </div>
      </div>
      <!-- Address Line 1-->
      <div class="row">
        <div class="col-12 col-md-8 col-sm-8 margin-bottom-medium">
          <ox-text-input
            [id]="'account_address'"
            [label]="'payment_BillingAddress'"
            [formGroupInput]="updatePmthForm"
            [formControlNameInput]="'accountHolderAddress'"
            [placeHolderText]="pmtMeth.creditCard.addressLine1"
            [inputName]="'address'"
            [classes]="'form-control'"
            (input)="isFormChanged($event)"
            trackLink = "{{disableClickTracking ?? ('payment_BillingAddress'| translate)}}"
            trackType = "{{disableClickTracking ? '':'o'}}"
            [prop15]="('payment_BillingAddress'| translate)"
            [prop10]="trackingString('input',[('payment_BillingAddress'| translate)])"
            [evar33]="trackingString('input',[('payment_BillingAddress'| translate)])"
            ></ox-text-input>
        </div>
      </div>
      <!-- City -->
      <div class="row">
        <div class="col-12 col-md-8 col-sm-8 margin-bottom-medium">
          <ox-text-input
            [id]="'account_city'"
            [label]="'payment_City'"
            [formGroupInput]="updatePmthForm"
            [formControlNameInput]="'accountHolderCity'"
            [placeHolderText]="pmtMeth.creditCard.addressCity"
            [inputName]="'city'"
            [classes]="'form-control'"
            [validationType]="'lettersAposHyphenSpace'"
            (input)="isFormChanged($event)"
            trackLink = "{{disableClickTracking ?? ('payment_City'| translate)}}"
            trackType = "{{disableClickTracking ? '':'o'}}"
            [prop15]="('payment_City'| translate)"
            [prop10]="trackingString('input',[('payment_City'| translate)])"
            [evar33]="trackingString('input',[('payment_City'| translate)])"
            ></ox-text-input>
        </div>
      </div>
      <!-- State -->
      <div class="row">
        <div class="col-12 col-md-8 col-sm-8">
            <ox-state-input
            [id]="'account_state_prov'"
            [validationType]="'alphaOnly'"
            [inputName]="'stateProvince'"
            [formGroupInput]="updatePmthForm"
            [formControlNameInput]="'stateProvince'"
            [formControlInput]="updatePmthForm.controls['stateProvince']"
            [placeHolderText]="pmtMeth.creditCard.addressStateProv"
            [stateCode]="pmtMeth.creditCard.addressStateProv"
            [label]="'State or Province'"
            (input)="isFormChanged($event)"
            trackLink = "{{disableClickTracking ?? ('account_state_prov'| translate)}}"
            trackType = "{{disableClickTracking ? '':'o'}}"
            [prop15]="('State or Province'| translate)"
            [prop10]="trackingString('dropdown',[('State or Province'| translate)])"
            [evar33]="trackingString('dropdown',[('State or Province'| translate)])">
          </ox-state-input>
        </div>
      </div>
      <!-- Postal Code -->
      <div class="row">
        <div class="col-12 col-md-8 col-sm-8 margin-bottom-medium">
          <ox-text-input
            [id]="'account_zip'"
            [label]="'payment_Zip'"
            [formGroupInput]="updatePmthForm"
            [formControlNameInput]="'postalCode'"
            [placeHolderText]="pmtMeth.creditCard.addressZipCode"
            [inputName]="'zip'"
            [classes]="'form-control'"
            (input)="isFormChanged($event)"
            trackLink = "{{disableClickTracking ?? ('account_zip'| translate)}}"
            trackType = "{{disableClickTracking ? '':'o'}}"
            [prop15]="('account_zip'| translate)"
            [prop10]="trackingString('input',[('account_zip'| translate)])"
            [evar33]="trackingString('input',[('account_zip'| translate)])"
            ></ox-text-input>
        </div>
      </div>
      <!-- Cancel/Save Buttons -->
      <webu-submit-cancel [form]="updatePmthForm" [saving]="savingPaymentInfo" [disableSaveButton]="disableSaveButton" (cancelClicked)="closeEditCreditCard()"(saveClicked)="updateCreditCard()"></webu-submit-cancel>
      </div>
    }
  </form> 
  }
</div>
}
